import { render, staticRenderFns } from "./fase-teste.vue?vue&type=template&id=94743e86&"
import script from "./fase-teste.vue?vue&type=script&lang=js&"
export * from "./fase-teste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports